import { GAEventName } from 'analytics/ga-event-name.enum';
import { createAnalyticsEvent } from 'analytics/create-analytics-event';

export const quizStartedEvent = createAnalyticsEvent<{
  quizId: string;
  quizName: string;
  quizVersion: string | number;
}>(({ quizId, quizName, quizVersion }) => ({
  event: GAEventName.QUIZ_STARTED,
  quiz_id: quizId,
  quiz_name: quizName,
  quiz_version: quizVersion
}));

export const quizStepEvent = createAnalyticsEvent<{
  quizId: string;
  stepNumber: number;
}>(({ quizId, stepNumber }) => ({
  event: GAEventName.QUIZ_STEP,
  quiz_id: quizId,
  step_number: stepNumber
}));

export const quizExitEvent = createAnalyticsEvent<{
  quizId: string;
  stepNumber: number;
}>(({ quizId, stepNumber }) => ({
  event: GAEventName.QUIZ_EXIT,
  quiz_id: quizId,
  step_number: stepNumber
}));

export const quizBackEvent = createAnalyticsEvent<{
  quizId: string;
  fromStep: number;
  toStep: number;
}>(({ quizId, fromStep, toStep }) => ({
  event: GAEventName.QUIZ_BACK_BUTTON,
  quiz_id: quizId,
  from_step: fromStep,
  to_step: toStep
}));

export const quizAnswerSelectionEvent = createAnalyticsEvent<{
  quizId: string;
  questionId: number;
  selectedAnswer: string | string[];
}>(({ quizId, questionId, selectedAnswer }) => ({
  event: GAEventName.QUIZ_ANSWER_SELECTION,
  quiz_id: quizId,
  question_id: questionId,
  selected_answer: selectedAnswer
}));

export const quizCompletedEvent = createAnalyticsEvent<{
  quizId: string;
  quizAnswers: {
    [key: number]: string[];
  };
}>(({ quizId, quizAnswers }) => ({
  event: GAEventName.QUIZ_COMPLETED,
  quiz_id: quizId,
  quiz_answers: quizAnswers
}));

// deprecated events

export const emailFillEvent = createAnalyticsEvent<{
  quizId: string;
}>(({ quizId }) => ({
  event: GAEventName.QUIZ_EMAIL_FILL,
  quiz_id: quizId
}));

export const viewResultsEvent = createAnalyticsEvent<{
  quizId: string;
  score: Record<string, number>[];
  quizAnswersId: string;
}>(({ quizId, score, quizAnswersId }) => ({
  event: GAEventName.QUIZ_VIEW_RESULTS,
  quiz_id: quizId,
  quiz_answers_id: quizAnswersId,
  score
}));

export const quizPopupActionEvent = createAnalyticsEvent<{
  detail: 'open' | 'close';
  url: string;
  location: string;
}>(({ detail, url, location }) => ({
  event: GAEventName.QUIZ_POPUP_ACTION,
  detail,
  url,
  location
}));
